/*ěščřžýáíéúů*/

// All Began Component JavaScript
document.addEventListener("DOMContentLoaded", function () {
    function initAllBeganSwiper() {
        // --- DOM odkazy nejdřív (kvůli init handlerům) ---
        var yearLinks = document.querySelectorAll(".year-link");
        var btnNext = document.querySelector(".buttons-all-began__next");
        var btnPrev = document.querySelector(".buttons-all-began__prev");

        // === Helpers (function declarations jsou hoistované) ===
        function arraySlides(swiper) {
            return Array.prototype.slice.call(swiper.slides || []);
        }

        function getContainerEl(swiper) {
            if (swiper && swiper.el && swiper.el.getBoundingClientRect) return swiper.el;
            if (swiper && swiper.wrapperEl) {
                var p = swiper.wrapperEl.parentNode || swiper.wrapperEl;
                if (p && p.getBoundingClientRect) return p;
            }
            if (swiper && swiper.$el && swiper.$el[0] && swiper.$el[0].getBoundingClientRect) {
                return swiper.$el[0];
            }
            return null;
        }

        function getVisibleSlideIndexes(swiper) {
            var slidesArr = arraySlides(swiper);

            // 1) Preferuj třídu od Swiperu (když ji verze poskytuje)
            var viaClass = [];
            for (var i = 0; i < slidesArr.length; i++) {
                var sl = slidesArr[i];
                if (sl.classList && sl.classList.contains("swiper-slide-visible")) {
                    viaClass.push(i);
                }
            }
            if (viaClass.length) return viaClass;

            // 2) Fallback: geometrie (překryv s kontejnerem)
            var container = getContainerEl(swiper);
            if (!container || !container.getBoundingClientRect) return [];
            var wrapRect = container.getBoundingClientRect();

            var visible = [];
            for (var j = 0; j < slidesArr.length; j++) {
                var r = slidesArr[j].getBoundingClientRect();
                var overlap = Math.min(r.right, wrapRect.right) - Math.max(r.left, wrapRect.left) > 0;
                if (overlap) visible.push(j);
            }
            return visible;
        }

        function syncState(swiper) {
            var slidesArr = arraySlides(swiper);

            // reset slidů
            for (var i = 0; i < slidesArr.length; i++) {
                var sl = slidesArr[i];
                sl.classList.remove("is-active");
                sl.setAttribute("aria-current", "false");
                var card = sl.querySelector(".card");
                if (card) card.classList.remove("is-active");
            }
            // reset roků
            yearLinks.forEach(function (l) {
                l.classList.remove("active");
            });

            // označ všechny viditelné
            var visibleIdx = getVisibleSlideIndexes(swiper);
            for (var k = 0; k < visibleIdx.length; k++) {
                var idx = visibleIdx[k];
                var s = slidesArr[idx];
                if (!s) continue;

                s.classList.add("is-active");
                s.setAttribute("aria-current", "true");
                var c = s.querySelector(".card");
                if (c) c.classList.add("is-active");

                var year = s.getAttribute("data-year");
                var link = document.querySelector('.year-link[data-year="' + year + '"]');
                if (link) link.classList.add("active");
            }

            // Fallback – kdyby nic nebylo viditelné, označ activeIndex
            if (visibleIdx.length === 0 && typeof swiper.activeIndex === "number") {
                var fi = Math.min(swiper.activeIndex, slidesArr.length - 1);
                var fs = slidesArr[fi];
                if (fs) {
                    fs.classList.add("is-active");
                    fs.setAttribute("aria-current", "true");
                    var fc = fs.querySelector(".card");
                    if (fc) fc.classList.add("is-active");

                    var fy = fs.getAttribute("data-year");
                    var fl = document.querySelector('.year-link[data-year="' + fy + '"]');
                    if (fl) fl.classList.add("active");
                }
            }
        }

        function updateYearProgress(swiper, forceEnd) {
            var yearSlider = document.querySelector(".years__slide");
            if (!yearSlider) return;

            if (swiper.isLocked) {
                yearSlider.style.setProperty("--progress-width", "100%");
                return;
            }
            var prog = typeof swiper.progress === "number" ? swiper.progress : 0;
            var percent = forceEnd ? 100 : Math.max(0, Math.min(100, prog * 100));
            yearSlider.style.setProperty("--progress-width", percent + "%");
        }

        // --- Swiper instance (bez vestavěné navigace; krokujeme sami po 1) ---
        var postsSwiper = new Swiper(".all-began__slider-swiper", {
            slidesPerView: "auto",
            spaceBetween: 16,
            loop: false,
            freeMode: false,
            watchSlidesProgress: true,
            observer: true,
            observeParents: true,

            // Krokování po jednom
            slidesPerGroup: 1,
            slidesPerGroupAuto: false,

            on: {
                init: function () {
                    syncState(this);
                    updateYearProgress(this);
                },
                slideChange: function () {
                    syncState(this);
                    updateYearProgress(this);
                },
                progress: function () {
                    syncState(this);
                    updateYearProgress(this);
                },
                setTranslate: function () {
                    syncState(this);
                },
                resize: function () {
                    syncState(this);
                    updateYearProgress(this);
                },
                reachEnd: function () {
                    updateYearProgress(this, true);
                },
                reachBeginning: function () {
                    updateYearProgress(this);
                },
            },
        });

        // --- Naše šipky: vždy posun o 1 slide ---
        if (btnNext) {
            btnNext.addEventListener("click", function (e) {
                e.preventDefault();
                var next = Math.min(postsSwiper.activeIndex + 1, postsSwiper.slides.length - 1);
                postsSwiper.slideTo(next);
            });
        }
        if (btnPrev) {
            btnPrev.addEventListener("click", function (e) {
                e.preventDefault();
                var prev = Math.max(postsSwiper.activeIndex - 1, 0);
                postsSwiper.slideTo(prev);
            });
        }

        // --- Klik na rok v liště ---
        yearLinks.forEach(function (yearLink) {
            yearLink.addEventListener("click", function () {
                var selectedYear = this.getAttribute("data-year");
                var slidesArr = arraySlides(postsSwiper);
                var targetIndex = -1;
                for (var i = 0; i < slidesArr.length; i++) {
                    if (slidesArr[i].getAttribute("data-year") === selectedYear) {
                        targetIndex = i;
                        break;
                    }
                }
                if (targetIndex >= 0) {
                    postsSwiper.slideTo(targetIndex);
                }
            });
        });

        // Startovní stav
        syncState(postsSwiper);
        updateYearProgress(postsSwiper);

        return postsSwiper;
    }

    if (document.querySelector(".all-began__slider-swiper")) {
        initAllBeganSwiper();
    }
});
